"use client";

import React from "react";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { getLink, Routes } from "@/constants";
import { Translations } from "@/translations";
import LearningToolsOverview from "@/components/learning-tools/Overview";
import { useEducationAvailability } from "@/hooks/useEducationAvailability";

interface MainProps {
  locale: string;
}

const MemoHeroSectionV2: React.FC<MainProps> = ({ locale }) => {
  const t = useTranslations("Homepage");
  const availability = useEducationAvailability();

  return (
    <>
      <LearningToolsOverview locale={locale} />
      {availability.status === "supported" && <div className="container" style={{ paddingBottom: "48px" }}>
        <section
          aria-labelledby="education-discovery-title"
          style={{ borderTop: "1px solid #dce8f4", paddingTop: "32px" }}
        >
          <h2 id="education-discovery-title" style={{ color: "#123a5c", fontSize: "28px", marginBottom: "8px" }}>
            {t(Translations.Homepage.DiscoveryTeaserTitle)}
          </h2>
          <p style={{ color: "#5e7385", marginBottom: "18px" }}>{t(Translations.Homepage.DiscoveryTeaserDescription)}</p>
          <Link href={getLink(locale, Routes.Education_Public_List)} className="e-btn e-btn-border" style={{ whiteSpace: "normal", height: "auto", minHeight: "44px", padding: "12px 24px", lineHeight: 1.4 }}>
            {t(Translations.Homepage.DiscoveryTeaserCta)}
            <i className="bi bi-arrow-right ms-2" aria-hidden="true" />
          </Link>
        </section>
      </div>}
    </>
  );
};

export default MemoHeroSectionV2;
